import { render, staticRenderFns } from "./PrivatePlotItem.vue?vue&type=template&id=10f65118&scoped=true&"
import script from "./PrivatePlotItem.vue?vue&type=script&lang=js&"
export * from "./PrivatePlotItem.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePlotItem.vue?vue&type=style&index=0&id=10f65118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f65118",
  null
  
)

export default component.exports